import { Component } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { TranslatePipe } from '@ngx-translate/core';
import { ComponentsModule } from '@nx-customer-apps/components';

@Component({
    selector: 'vp-error-403',
    templateUrl: './error-403.component.html',
    styleUrls: ['../errors.scss'],
    imports: [MatButton, ComponentsModule, TranslatePipe]
})
export class Error403Component {}
